import React from "react";

const STATUS = {
  present: { symbol: "P", label: "Presente", className: "border-emerald-500/40 bg-emerald-500/15 text-emerald-300" },
  absent: { symbol: "F", label: "Ausente", className: "border-rose-500/40 bg-rose-500/15 text-rose-300" },
  justified: { symbol: "J", label: "Falta justificada", className: "border-amber-400/40 bg-amber-400/15 text-amber-200" },
  not_eligible: { symbol: "—", label: "Não elegível", className: "border-transparent bg-transparent text-slate-700" },
};

const formatDate = (value) => value ? String(value).split("-").reverse().join("/") : "—";

export const AttendanceMatrix = ({ sessions = [], members = [] }) => {
  if (sessions.length === 0) {
    return <div data-testid="attendance-empty-sessions" className="border-y border-slate-800 py-16 text-center text-sm text-slate-500">Nenhuma sessão realizada/encerrada corresponde aos filtros.</div>;
  }
  return (
    <div className="relative max-h-[68vh] w-full overflow-auto rounded-lg border border-white/10 bg-[#0B0F19]" data-testid="attendance-matrix-scroll">
      <table className="w-full min-w-max border-collapse text-left text-xs" data-testid="attendance-matrix-table">
        <thead className="sticky top-0 z-30 bg-[#0F1523]">
          <tr className="border-b border-white/10 text-[10px] font-bold uppercase tracking-wider text-slate-400">
            <th className="sticky left-0 z-40 min-w-[230px] border-r border-white/10 bg-[#0F1523] px-3 py-3 shadow-[5px_0_14px_rgba(0,0,0,0.4)]">Irmão</th>
            <th className="min-w-[130px] px-3 py-3">Grau</th>
            <th className="px-3 py-3 text-center">Vis.</th>
            <th className="px-3 py-3 text-center text-emerald-300">P</th>
            <th className="px-3 py-3 text-center text-rose-300">F</th>
            <th className="px-3 py-3 text-center text-amber-200">J</th>
            <th className="px-3 py-3 text-center">Total</th>
            <th className="min-w-[110px] px-3 py-3 text-center">Frequência</th>
            {sessions.map((session) => (
              <th key={session.id} title={`${session.title} • ${session.degree_required}`} className="min-w-[86px] border-l border-white/5 px-2 py-2 text-center normal-case tracking-normal">
                <span className="block font-mono text-[10px] text-[#D4AF37]">{session.session_number}</span>
                <span className="mt-1 block text-[10px] text-slate-300">{formatDate(session.date)}</span>
                <span className="mt-1 block max-w-[80px] truncate text-[9px] text-slate-600">{session.degree_required?.replace(/^\d\s-\s/, "")}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-white/5">
          {members.map((member) => (
            <tr key={member.id} data-testid={`attendance-member-row-${member.id}`} className="group hover:bg-white/[0.035]">
              <td className="sticky left-0 z-20 border-r border-white/10 bg-[#0B0F19] px-3 py-3 shadow-[5px_0_14px_rgba(0,0,0,0.35)] group-hover:bg-[#101725]">
                <strong className="block max-w-[210px] truncate text-sm text-white">{member.name}</strong>
                <span className="mt-0.5 block font-mono text-[10px] text-slate-500">CIM {member.cim || "—"}</span>
              </td>
              <td className="px-3 py-3 text-slate-300">{member.degree || "—"}</td>
              <td className="px-3 py-3 text-center font-mono text-slate-500">{member.visits}</td>
              <td className="px-3 py-3 text-center font-mono font-bold text-emerald-300">{member.present}</td>
              <td className="px-3 py-3 text-center font-mono font-bold text-rose-300">{member.absent}</td>
              <td className="px-3 py-3 text-center font-mono font-bold text-amber-200">{member.justified}</td>
              <td className="px-3 py-3 text-center font-mono text-white">{member.eligible_total}</td>
              <td className="px-3 py-3">
                <div className="flex items-center gap-2">
                  <div className="h-1.5 w-14 overflow-hidden rounded-full bg-slate-800"><div className="h-full rounded-full bg-[#D4AF37]" style={{ width: `${member.frequency_pct}%` }} /></div>
                  <span className="min-w-[38px] text-right font-mono font-bold text-white">{member.frequency_pct}%</span>
                </div>
              </td>
              {member.cells.map((cell) => {
                const status = STATUS[cell.status] || STATUS.not_eligible;
                return (
                  <td key={cell.session_id} className="border-l border-white/5 px-2 py-2 text-center">
                    <span aria-label={status.label} title={status.label} data-testid={`attendance-cell-${member.id}-${cell.session_id}`} className={`inline-grid h-7 w-7 place-items-center rounded-full border text-[10px] font-black ${status.className}`}>{status.symbol}</span>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};